function ab_new_bid_confirmation_dialog_layout() {
  return AB.test('or_new_bid_confirmation_dialog_layout') === 'B';
};
/****

  function to show a confirm dialog. the callback must be a function which will be called (most of the time) when the dialog is completed.
  If a user cancels dialog by clicking outside of the window it will not be called.
  callback arguments is an object : { confirmed: boolean }

*/
var cw_confirmdialog_eventhandler = null;
function cw_show_confirm_dialog(title, message, callback, btn_yes, btn_no, footer_message) {
  btn_yes = btn_yes || (typeof TRANSLATIONS != 'undefined' && TRANSLATIONS['yes']) || 'Yes';
  btn_no = btn_no || (typeof TRANSLATIONS != 'undefined' && TRANSLATIONS['no']) || 'No';

  function set_cw_confirmdialog_eventhandler(confirmed) {
    if (!cw_confirmdialog_eventhandler.finished) cw_confirmdialog_eventhandler.callback({ confirmed: confirmed });
    cw_confirmdialog_eventhandler = { finished: true, callback: null };
  }

  if (!cw_confirmdialog_eventhandler) {
    cw_confirmdialog_eventhandler = { finished: false, callback: callback };
    $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_true",function (e) {
      e.preventDefault();
      if ($('#credit_card_selection').data('hide-on-confirm')) {
        cw_confirmdialog_eventhandler.callback({ confirmed: true });
        cw_confirmdialog_eventhandler.finished = false;
      } else {
        $("#cw_modal_confirmdialog").modal("hide");
        set_cw_confirmdialog_eventhandler(true);
      }
    });
    $("#cw_modal_confirmdialog").on('click',"#cw_modal_confirmdialog_false",function (e) {
      e.preventDefault();
      $("#cw_modal_confirmdialog").modal("hide");

      set_cw_confirmdialog_eventhandler(false);
    })
  }
  else {
    cw_confirmdialog_eventhandler.finished = false;
    cw_confirmdialog_eventhandler.callback = callback;
  }

  var modal = $("#cw_modal_confirmdialog");
  $(".cw-modal-header h1", modal).html(title);
  $(".cw-modal-body", modal).html(message);
  $("#cw_modal_confirmdialog_true", modal).html(btn_yes);
  if (ab_new_bid_confirmation_dialog_layout()) {
    $("#cw_modal_confirmdialog_true", modal).addClass('btn-single');
    $("#cw_modal_confirmdialog_false", modal).remove();
    var dismiss_button = $('<a>', {
      class: 'c-bid-confirm-modal__close js-bid-confirm-modal-dismiss',
      click: function(e) {
        e.preventDefault();
        $("#cw_modal_confirmdialog").modal("hide");

        set_cw_confirmdialog_eventhandler(false);
      }
    });
    modal.prepend(dismiss_button);
  } else {
    $("#cw_modal_confirmdialog_false", modal).html(btn_no);
  }

  if(typeof footer_message !== 'undefined') $('#cw_modal_footer_message', modal).html(footer_message);

  $.cwNiceSelects();
  try {
    modal.modal();
  } catch(err) {
    cw_confirmdialog_eventhandler.callback({confirmed: confirm(message)});
  }
}

/****

  function to show a an alert dialog box.

*/

var cw_alertdialog_eventhandler = null;
var cw_alertdialog_eventhandler_installed = false;

function cw_show_alert_dialog(title,message,callback,custom_btn) {

  var modal = $("#cw_modal_alertdialog");
  $(".cw-modal-header h1",modal).html(title)
  $(".cw-modal-body",modal).html(message)

  if(custom_btn && custom_btn.length){
    $(".cw-modal-close",modal).html(custom_btn)
  }

  // override previous eventhandler. or create it for the first time.
  cw_alertdialog_eventhandler = callback;

  // installation of the eventhandler happens only once.
  if (!cw_alertdialog_eventhandler_installed) {
        modal.on('hidden',function () {
          if (cw_alertdialog_eventhandler) cw_alertdialog_eventhandler()
        });
        cw_alertdialog_eventhandler_installed = true
  }

  try {
    modal.modal()
  } catch(err) {
    alert(message);
  }
}

var loadContentIfVisible = function(contentPlaceholder, eventName, onSuccess) {
  var $window = $(window);
  var viewportHeight = $window.height();
  var viewportScroll = $window.scrollTop();
  var contentTop = contentPlaceholder.offset().top;
  var isVisible = (contentTop - viewportScroll) < viewportHeight;

  if (isVisible) {
    $window.off(eventName);

    $.ajax(contentPlaceholder.data().path, {
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      }
    }).then(function(response) {
      contentPlaceholder.html(response).removeClass('cw-spinner-on');
      onSuccess.apply(this);
    });
  }

}
